<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="350px"
    @keydown.esc="closeDialog"
  >
    <v-card>
      <div class="dialog-container">
        <div class="dialog-header">
          <h3 class="header-title">주소록 추가</h3>
        </div>
        <p class="desc">
          <span class="add_name">{{ attendeesString }}</span
          >을 주소록에 추가합니다.
        </p>
        <div style="display: flex; justify-content: center;">
          <input
            style="width: 275px; padding: 10px; font-size: 12px;"
            placeholder="주소록 그룹명을 입력하세요"
            v-model="bookmarkName"
            v-on:keyup.enter="createBookmark()"
          />
        </div>
        <div class="danger-alert" v-if="error">
          {{ error }}
        </div>
        <div class="btnArea">
          <button class="close-btn" @click="closeDialog()">
            닫기
          </button>
          <button class="invite-btn" @click="createBookmark">
            저장
          </button>
        </div>
      </div>
    </v-card>
  </v-dialog>
</template>
<script>
import Util from "@/util";

export default {
  components: {},
  props: ["dialog", "attendees", "closeDialog"],
  data() {
    return {
      userKey: null,
      email: null,
      loading: true,
      error: null,
      bookmarkName: "",
    };
  },
  computed: {
    attendeesString() {
      let attendees_str = "";
      if (this.attendees.length === 1) {
        if (this.attendees[0].name) {
          attendees_str = `${this.attendees[0].name}`;
        } else {
          attendees_str = `${this.attendees[0].email}`;
        }
      } else if (this.attendees.length > 1) {
        if (this.attendees[0].name) {
          attendees_str = `${this.attendees[0].name} 외 ${this.attendees
            .length - 1}명`;
        } else {
          attendees_str = `${this.attendees[0].email} 외 ${this.attendees
            .length - 1}명`;
        }
      }
      return attendees_str;
    },
  },
  mounted() {
    this.loading = false;
  },
  methods: {
    init() {
      this.error = null;
      this.bookmarkName = "";
    },
    close() {
      this.init();
      this.closeDialog();
    },
    async createBookmark() {
      
      if (this.bookmarkName === "" || this.bookmarkName === null) {
        this.error = "그룹명이 입력되지 않았습니다.";
        return;
      }

      let attendees = this.attendees.map(obj => {
        return {
          department: obj.department,
          deptCode: obj.deptCode,
          deptFullName: obj.deptFullName,
          deptName: obj.deptName,
          deptUpperCode: obj.deptUpperCode,
          displayFullName: obj.displayFullName,
          displayName: obj.displayName,
          displaySaehaName: obj.displaySaehaName,
          email: obj.email,
          phone: obj.phone,
          empNum: obj.empNum,
          grade: obj.grade,
          name: obj.name,
          officeNumber: obj.officeNumber,
          positionCode: obj.positionCode,
          positionName: obj.positionName,
          status: obj.status,
          userKey: obj.userKey,
          userName: obj.userName,
          DEPT_NM: obj.DEPT_NM,
          DUTY_NM: obj.DUTY_NM,
          DEPT_CD: obj.DEPT_CD,
          isPersonalAddr: obj.isPersonalAddr ? true : false,
        };
      });
      this.userKey = decodeURI(decodeURIComponent(Util.getParam("userKey")));
      this.email =
        decodeURI(decodeURIComponent(Util.getParam("userKey"))) + "@krx.co.kr";
  
      let email = "";
      if (!Util.isEmpty(this.userKey)) {
        // 연계 파트
        email = this.email;
      } else {
        email = this.$store.state.user.email;
      }

      
      let bookmarkInfo = {
        owner: email,
        name: this.bookmarkName,
        attendees: attendees,
      };

      await this.$http
        .post("/api/v1/users/bookmark", bookmarkInfo)
        .then(response => {
          let ret = response.data;
          let meetingInfo = response.data;
          if (ret === "ok") {
            this.close();
            Util.snackBarOpen(
              this.$t("page.meeting-reserve.bookmark.add-bookmark-msg"),
              "success"
            );
          } else {
            this.error = meetingInfo;
          }
        })
        .catch(error => {
          this.error = error.response.data.error;
        });
    },
  },
};
</script>
<style scoped>
.dialog-container {
  width: 350px;
  box-shadow: 1px 1px 18px 0px rgba(50, 50, 50, 0.37);
}
.invite-btn {
  background-color: #604af3;
  color: white;
  width: 100px;
  height: 48px;
  border-radius: 8px;
  margin: 0 5px;
  font-size: 15px;
}
.close-btn {
  width: 82px;
  height: 48px;
  border-radius: 8px;
  background: #f2f2f2;
  color: #1f2e3d;
  margin: 0 5px;
  font-size: 15px;
}

.desc {
  font-size: 14px;
  text-align: center;
  margin: 30px 0 18px 0;
}
.add_name {
  color: #604af3;
  font-weight: 500;
}

.btnArea {
  text-align: right;
}

.btnArea button:hover {
  opacity: 0.7;
}
</style>



// WEBPACK FOOTER //
// src/components/popup/BookmarkCreateDialog.vue